import DailyReport from './DailyReport';

export default DailyReport;
